import { ValueProvider } from '@angular/core';
import { DIALOG_DEFAULT_CONFIG } from './dialog-tokens';
import { DialogConfigBase } from './dialog.model';

/**
 * A provider function to configure DialogService
 * @param options Options to configure DialogService
 * @returns A provider object
 */
export const provideDialogDefaultConfig = (
  options: DialogConfigBase
): ValueProvider => ({
  provide: DIALOG_DEFAULT_CONFIG,
  useValue: options,
});
